export class TransferSummaryReport {
  public transferSummaries: TransferSummary[];
}

export class TransferSummary {
  dateKey: string;
  details: TransferSummaryDetail[];
}

export class TransferSummaryDetail {
  gate: string;
  finished: number;
  noShow: number;
}

export class TransferSummaryExcelRow {
  public constructor(
    dateKey: string,
    finished: number,
    noShow: number,
    gate: string
  ) {
    this.dateKey = dateKey;
    this.finished = finished;
    this.noShow = noShow;
    this.gate = gate;
  }
  dateKey: string;
  finished: number;
  noShow: number;
  gate: string;
}